import { Record } from 'immutable';
import PhotoHash from './PhotoHash';

const ReviewDefaults = {
  id: null,
  rating: null,
  review: '',
  reviewer_name: '',
  reviewer_title: null,
  reviewer_photo_hash: null,
  reviewer_is_influencer: false,
  reviewed_at: null
};

class Review extends Record(ReviewDefaults) {
  constructor(values) {
    values.reviewer_photo_hash = (values.reviewer_photo_hash instanceof PhotoHash) ? values.reviewer_photo_hash : new PhotoHash(values.reviewer_photo_hash);

    super(values);
  }
}

export default Review;



// WEBPACK FOOTER //
// banquet/models/Review.js